// extracted by mini-css-extract-plugin
export default {"menuHeader":"MenuModal_menuHeader__4LdXM","menuContainer":"MenuModal_menuContainer__gyxVa","menuItem":"MenuModal_menuItem__rLynQ"};